import { apiURL } from "./constants";
import axios from "axios";


export async function getAccounts(params = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/account/`, {
        params,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

// eslint-disable-next-line no-unused-vars
export async function readAccounts(searchTerm = '', _unusedParam = '') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const params = {
        page: 1,
        page_size: 30,
        pagination: true,
        ordering: 'name',
    };

    if (searchTerm) {
        params.search = searchTerm;
    }

    const response = await axios.get(`${apiURL}/api/account/`, {
        params,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });

    return response;
}

export async function getAccount(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/account/${id}/`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function createAccount(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.post(`${apiURL}/api/account/`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response; 
}

export async function updateAccount(id, payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.put(`${apiURL}/api/account/${id}/`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function deleteAccount(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.delete(`${apiURL}/api/account/${id}/`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

